import { useEffect } from "react";

export function useClickOutside(ref, callback, outTreeRef = null) {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        ref &&
        ref.current &&
        !ref.current.contains(event.target) &&
        !(outTreeRef && outTreeRef.current && outTreeRef.current.contains(event.target))
      ) {
        callback();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [ref, callback, outTreeRef]);
}
